import React from 'react';

function CheckBullets(props: object) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5443 2.18883C15.3089 1.95305 14.927 1.95264 14.6916 2.18783L7.45748 9.40289L4.84741 6.56811C4.62188 6.3233 4.24057 6.30743 3.99535 6.53293C3.75032 6.75846 3.73463 7.13996 3.96016 7.38499L6.99535 10.6813C7.10651 10.8021 7.26207 10.8722 7.4261 10.8756C7.43051 10.8758 7.43476 10.8758 7.43898 10.8758C7.59838 10.8758 7.75173 10.8125 7.8647 10.7L15.5431 3.04168C15.7791 2.80652 15.7795 2.42461 15.5443 2.18883Z"
        fill="currentColor"
      />
      <path
        d="M15.397 7.39697C15.0639 7.39697 14.794 7.66691 14.794 8C14.794 11.7463 11.7463 14.794 8 14.794C4.25387 14.794 1.20603 11.7463 1.20603 8C1.20603 4.25387 4.25387 1.20603 8 1.20603C8.33306 1.20603 8.60303 0.936094 8.60303 0.603031C8.60303 0.269938 8.33306 0 8 0C3.58875 0 0 3.58875 0 8C0 12.4111 3.58875 16 8 16C12.4111 16 16 12.4111 16 8C16 7.66694 15.7301 7.39697 15.397 7.39697Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CheckBullets;
